import React from "react";
import { Routes, Route } from "react-router-dom";
import AuthenticationGate from "./AthenticationGate";
import Overview from "../Components/Overview/Overview";
import SwiftDay from "../Components/Swift/SwiftDay/SwiftDay";
import InternalAlerts from "../Components/Alerts/InternalAlerts/InternalAlerts";
import MatchingRules from "../Components/Mathcing/MatchingRules/MatchingRules";
import Reports from "../Components/Reporting/Reports/Reports";
import License from "../Components/License/License";
import SwiftMessages from "../Components/Swift/SwiftMessages";

const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Overview />} />
      <Route
        path="/swift-day"
        element={
          <AuthenticationGate>
            <SwiftDay />
          </AuthenticationGate>
        }
      />
      <Route
        path="/swift-search"
        element={
          <AuthenticationGate>
            <SwiftMessages />
          </AuthenticationGate>
        }
      />

      <Route
        path="/internal-alerts"
        element={
          <AuthenticationGate>
            <InternalAlerts />
          </AuthenticationGate>
        }
      />
      <Route
        path="/alerts-settings"
        element={
          <AuthenticationGate>
            <InternalAlerts />
          </AuthenticationGate>
        }
      />

      <Route
        path="/matching-rules"
        element={
          <AuthenticationGate>
            <MatchingRules />
          </AuthenticationGate>
        }
      />
      <Route
        path="/matching-day"
        element={
          <AuthenticationGate>
            <MatchingRules />
          </AuthenticationGate>
        }
      />

      <Route
        path="/reports"
        element={
          <AuthenticationGate>
            <Reports />
          </AuthenticationGate>
        }
      />
      <Route
        path="/license"
        element={
          <AuthenticationGate>
            <License />
          </AuthenticationGate>
        }
      />

      <Route
        path="/admin-tool/bank-settings"
        element={
          <AuthenticationGate>
            <License />
          </AuthenticationGate>
        }
      />
      <Route
        path="/admin-tool/alerts-notifications"
        element={
          <AuthenticationGate>
            <License />
          </AuthenticationGate>
        }
      />
      <Route
        path="/admin-tool/search-archive"
        element={
          <AuthenticationGate>
            <License />
          </AuthenticationGate>
        }
      />

      <Route
        path="/user-management/users"
        element={
          <AuthenticationGate>
            <License />
          </AuthenticationGate>
        }
      />
    </Routes>
  );
};

export default AllRoutes;
